import { render, staticRenderFns } from "./PendingItemCard.vue?vue&type=template&id=4b3914b2&scoped=true&"
import script from "./PendingItemCard.vue?vue&type=script&lang=js&"
export * from "./PendingItemCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3914b2",
  null
  
)

export default component.exports